import type { Dayjs } from 'dayjs';

import { useDateTimeConfig } from '@treneo/shared/contexts';
import {
  convertTimeFormatToDayjs,
  createDayjsInstance,
  createUtcDayjs
} from '@treneo/shared/utils';

type Props = {
  date: Date | string;
  timezone?: string;
  format?: string;
  showTimezone?: boolean;
  useConfigFormat?: boolean;
};

export const TimeInfo = ({
  date,
  timezone: targetTimezone,
  format,
  showTimezone = false,
  useConfigFormat = true
}: Readonly<Props>) => {
  const { timeFormat } = useDateTimeConfig();

  if (!date) {
    return <span />;
  }

  let dayjsDate: Dayjs;

  if (targetTimezone) {
    dayjsDate = createUtcDayjs(date).tz(targetTimezone);
  } else {
    dayjsDate = createDayjsInstance(date);
  }

  let formatted: string;

  if (useConfigFormat && !format) {
    const formatToUse = convertTimeFormatToDayjs(timeFormat);
    formatted = dayjsDate.format(formatToUse);
  } else {
    const formatToUse = format ?? 'HH:mm';
    formatted = dayjsDate.format(formatToUse);
  }

  const displayText =
    showTimezone && targetTimezone ? `${formatted} ${dayjsDate.format('z')}` : formatted;

  return <span>{displayText}</span>;
};
